import React from 'react';
import styled, { css } from 'styled-components';
import { brandColours, fontSize, standardColours } from '../styles';
import { Svg } from './ui';
import giftIcon from '../images/gift-icon.svg';

const StyledVouchersButton = styled.button`
  padding: 0;
  ${fontSize(12)};
  text-decoration: underline;
  white-space: nowrap;

  svg {
    display: block;
    margin: auto auto 5px;
    height: 12px;
    width: 12px;
  }

  span {
    display: block;
  }

  ${({ altTheme }) => {
    if (altTheme) {
      return css`
        color: ${standardColours.white};

        svg {
          fill: ${standardColours.white};
        }
      `;
    } else {
      return css`
        svg {
          fill: ${brandColours.primary};
        }
      `;
    }
  }}
`;

const VoucherButton = ({ altTheme, ...props }) => (
  <StyledVouchersButton altTheme={altTheme} {...props}>
    <Svg image={giftIcon} />
    View Gift Voucher
    <span>Packages</span>
  </StyledVouchersButton>
);

export default VoucherButton;
